/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-23 23:01:10 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2020-04-15 12:47:56
 */


import React from "react"
import { Switch, Route } from "react-router-dom"
import ClientInvoice from "./ClientInvoice"
import CounsellorInvoice from "./CounsellorInvoice"
import { connect, useSelector } from 'react-redux'
import auth from '../auth'

import * as constants from "./constants"
import AdminHomepage from "./AdminHomepage"

const Routes = () => {
  const isAdmin = useSelector(state => state.auth.profile.isAdmin)

  return (
    <Switch>
      {
        isAdmin &&
        <Route path={constants.pages.counsellorInvoice} component={CounsellorInvoice} isExact />
        // <Route path={constants.pages.counsellorInvoice} component={CounsellorInvoice} isExact />
      }
      {
        isAdmin &&
        <Route path={constants.pages.adminHomePage} component={AdminHomepage} isExact />
      }
      
      <Route path={constants.pages.clientInvoice} component={ClientInvoice} isExact />
    </Switch>
  )
}

export default Routes